import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import PhproductformDashboard from '../PhproductformDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function PhproductformPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < PhproductformDashboard />
    )

}